import { jsx } from 'panel';
import { SelectEl } from 'common/components/select';
import { SvgIconEl } from 'common/components/svg-icon';
export function template() {
  const showNewNav = this.helpers.isOnNewNav();
  return jsx(SelectEl, {
    attrs: {
      elref: "searchDropdownMenu",
      icon: "brand-search",
      'icon-only': true,
      'menu-height': 500,
      'menu-width': window.matchMedia("(max-width: 1150px)").matches ? 290 : 448,
      open: this.attr("open"),
      'preserve-search-on-close': true,
      'search-placeholder': "Search Reports & Dashboards",
      'search-threshold': 0,
      'show-clear': true
    },
    class: {
      'shift-select': showNewNav
    },
    props: {
      sectionsFromInputFn: this.helpers.searchSectionsFromInput,
      sections: this.helpers.getSearchSections()
    },
    on: {
      change: this.helpers.handleSearchSelection,
      focusItem: this.helpers.handleFocusItem,
      menuChange: this.helpers.handleSelectMenuChanged,
      searchFilterChange: this.helpers.handleSearchFilterChange
    }
  }, jsx("div", {
    sel: '.mp-chrome-header-trigger-container-icon',
    attrs: {
      slot: "trigger"
    },
    class: {
      selected: this.attr("open")
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "search"
    }
  })));
}